import { Link } from 'react-router';

import { ToggleButton, ToggleButtonGroup } from '../shared/ToggleButton';
import { PortalPollsOverview } from './PortalPollsOverview';
import { PortalPostLibrary } from './PortalPostLibrary';
import { PortalSettingsLibrary } from './PortalSettingsLibrary';
import { PortalTranslations } from './PortalTranslations';
import { PortalPublicationFeed } from './publication/PortalPublicationFeed';
import { Section } from '../shared';
import { UserRoles } from '@lifeserver/shared';

import { useIsAuthorized } from '../hooks/useIsAuthorized';

import { RouteTo } from '../routes';

import styles from './Portal.module.scss';

export interface PortalProps {
    view?: 'library' | 'publication' | 'polls' | 'settings' | 'translations';
}

export const Portal = ({ view = 'library' }: PortalProps) => {
    const scheduleAuthorization = useIsAuthorized(
        UserRoles.PortalWriteSchedule,
    );

    return (
        <Section className={styles.container}>
            <menu className={styles.navigation}>
                <ToggleButtonGroup value={view} color="primary">
                    <Link to={RouteTo.PortalLibrary()}>
                        <ToggleButton value="library">
                            Post Library
                        </ToggleButton>
                    </Link>

                    {(scheduleAuthorization.isAuthorized ||
                        scheduleAuthorization.isLoading) && (
                        <Link to={RouteTo.PortalPublication()}>
                            <ToggleButton value="publication">
                                Publication Feed
                            </ToggleButton>
                        </Link>
                    )}

                    <Link to={RouteTo.PortalPolls()}>
                        <ToggleButton value="polls">
                            Polls Overview
                        </ToggleButton>
                    </Link>

                    <Link to={RouteTo.PortalSettings()}>
                        <ToggleButton value="settings">
                            Portal Settings
                        </ToggleButton>
                    </Link>
                    <Link to={RouteTo.PortalTranslations()}>
                        <ToggleButton value="translations">
                            Portal Translations
                        </ToggleButton>
                    </Link>
                </ToggleButtonGroup>
            </menu>
            {view === 'library' ? (
                <PortalPostLibrary />
            ) : view === 'publication' ? (
                <PortalPublicationFeed />
            ) : view === 'polls' ? (
                <PortalPollsOverview />
            ) : view === 'settings' ? (
                <PortalSettingsLibrary />
            ) : view === 'translations' ? (
                <PortalTranslations />
            ) : null}
        </Section>
    );
};
